import { render, staticRenderFns } from "./UpsellItem.vue?vue&type=template&id=1b47d907&scoped=true"
import script from "./UpsellItem.vue?vue&type=script&lang=js"
export * from "./UpsellItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47d907",
  null
  
)

export default component.exports